import VariableChip from '@/components/common/chips/VariableChip';
import VariablePicker from '@/components/nodes/settings/variable/VariablePicker';
import { useApplication } from '@/hooks/useApplication';
import { useMetadata } from '@/hooks/useMetadata';
import { emptyValue } from '@/types/detail';
import { Severity } from '@/types/validation';
import { VariableRef, VariableScope } from '@/types/variable';
import { isString, isVariable } from '@/util/typeGuards';
import { getVariableTypeLabel } from '@/util/variables';
import { FC, useState } from 'react';

type VariableProps = {
  subroutineId: number;
  label?: string;
  type: string | string[];
  valueKey?: string;
  initialValue?: VariableRef | emptyValue;
  scope?: VariableScope;
  onChange: (newVariable?: VariableRef | emptyValue) => void;
  allowEmpty?: boolean;
  required?: boolean;
  errorSeverity?: Severity;
};

const VariableView: FC<VariableProps> = (props) => {
  const { application } = useApplication();
  const { metadata } = useMetadata();

  const [openVars, setOpenVars] = useState(false);

  const variableType = isVariable(props.initialValue)
    ? getVariableTypeLabel(props.initialValue, application, metadata, props.subroutineId)
    : undefined;
  const type = props.type?.toString() || variableType;
  const pickerType = props.type ? (isString(props.type) ? [props.type] : [...props.type]) : ['any'];

  return (
    <>
      <VariableChip
        label={props.label}
        onClick={() => setOpenVars(true)}
        onDelete={() => props.onChange()}
        type={type}
        variableType={variableType}
        value={props.initialValue}
        chipText={isVariable(props.initialValue) ? props.initialValue.name : undefined}
        scope={isVariable(props.initialValue) ? props.initialValue.scope : undefined}
        required={props.required}
        error={props.errorSeverity}
        allowEmpty={props.allowEmpty}
        onEmptyClick={() => props.onChange({ empty: true })}
      />
      <VariablePicker
        subroutineId={props.subroutineId}
        open={openVars}
        onClose={() => setOpenVars(false)}
        type={pickerType}
        onVariablePicked={(newVariable) => props.onChange(newVariable)}
        scope={props.scope ? [props.scope] : undefined}
      />
    </>
  );
};

export default VariableView;
